import { getEndOfQuarter } from "common/date-utils";
export var TopFilterGroup;
(function (TopFilterGroup) {
    TopFilterGroup["customGroup"] = "CustomGroup";
})(TopFilterGroup || (TopFilterGroup = {}));
export var PredefinedFilterName;
(function (PredefinedFilterName) {
    PredefinedFilterName[PredefinedFilterName["Last6Months"] = 0] = "Last6Months";
})(PredefinedFilterName || (PredefinedFilterName = {}));
export var DateFilterOptions;
(function (DateFilterOptions) {
    DateFilterOptions["equals"] = "equals";
    DateFilterOptions["greaterThan"] = "greaterThan";
    DateFilterOptions["inRange"] = "inRange";
    DateFilterOptions["lessThan"] = "lessThan";
    DateFilterOptions["notEqual"] = "notEqual";
})(DateFilterOptions || (DateFilterOptions = {}));
export var NumberFilterOptions;
(function (NumberFilterOptions) {
    NumberFilterOptions["equals"] = "equals";
    NumberFilterOptions["notEqual"] = "notEqual";
    NumberFilterOptions["lessThan"] = "lessThan";
    NumberFilterOptions["lessThanOrEqual"] = "lessThanOrEqual";
    NumberFilterOptions["greaterThan"] = "greaterThan";
    NumberFilterOptions["greaterThanOrEqual"] = "greaterThanOrEqual";
    NumberFilterOptions["inRange"] = "inRange";
    NumberFilterOptions["blank"] = "blank";
    NumberFilterOptions["notBlank"] = "notBlank";
    NumberFilterOptions["top"] = "Top";
    NumberFilterOptions["bottom"] = "Bottom";
})(NumberFilterOptions || (NumberFilterOptions = {}));
export const PredefinedFilters = {
    [PredefinedFilterName.Last6Months]: (asOfDate) => {
        if (asOfDate) {
            const last6Months = new Date(asOfDate.getFullYear(), asOfDate.getMonth() - 6, 1);
            const date = getEndOfQuarter(last6Months);
            return {
                dateFrom: `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} 00:00:00`,
                dateTo: `${asOfDate.getFullYear()}-${asOfDate.getMonth() + 1}-${asOfDate.getDate()} 00:00:00`,
                filterType: "date",
                type: DateFilterOptions.inRange
            };
        }
        return {};
    }
};
